import React from 'react';

const About = () => {
  return (
    <div className="px-8 py-8 mx-4 mt-12 md:pl-8 md:mx-16 sm:mx-10 border border-[#3D464D] rounded-lg bg-transparent">
      <h2 className='text-base md:text-lg text-[#FFFFFF] mb-3 md:mb-5 font-bold'>About Wynk Music
        <p className='text-xs md:text-sm text-[#C3C2C3] font-medium font-sans mt-2'>
          Wynk Music is a complete package that allows you free online music
          streaming, set caller tunes, listen to podcasts, download MP3 music
          offline, and much more! Since music is essentially the only thing
          that can truly understand a person, we consistently offer our
          audience the ideal blend of MP3 Songs by their favourite artists and
          of versatile genres.
        </p>
      </h2>

      <h2 className='text-base md:text-lg text-[#FFFFFF] mb-3 md:mb-5 font-bold'>Play & Download FREE MP3 Songs in all languages
        <p className='text-xs md:text-sm text-[#C3C2C3] font-medium font-sans mt-2'>
          One of the unique features of Wynk Music is that it offers users the
          ability to stream music in multiple regional languages, including
          Hindi, Punjabi, Bengali, Tamil, Telugu, and more. Also, users of the
          app can download MP3 songs for offline listening. This online music
          platform provides access to additional features such as offline
          listening, high-quality audio, and exclusive content.
        </p>
      </h2>

      <h2 className='text-base md:text-lg text-[#FFFFFF] mb-3 md:mb-5 font-bold'>Wynk Music – One Stop Destination for Offline & Online Music!
        <p className='text-xs md:text-sm text-[#C3C2C3] font-medium font-sans mt-2'>
          Wynk Music offers users access to a vast library of music, including
          Indian and international tracks across various genres like
          Bollywood, Punjabi, pop, rock, and more. We have made online music
          streaming simple, fun, and all about you! So, what’s the wait for,
          discover and listen to millions of songs, playlists, podcasts &
          download MP3 songs on any device including mobile for free
          exclusively on Wynk Music. Keep Wynking!
        </p>
      </h2>
    </div>
  );
};

export default About;